<template>
    <div>
        <div class="ml-auto mb-3 text-right">
            <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                :data="exportData"
                :fields="exportFields"
                :header="exportHeaders"
                type="csv"
                :escapeCsv="false"
                :name="exportFileName">
                <span>CSV</span>
            </exportCSV>
            <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                <span class="mr-3">PDF</span>
                <i class="arrow-down fas fa-angle-down"></i> 
            </button> -->
        </div>
        <div v-if="selectedTab != 'staff'" class="row">
            <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter mb-2">
                    <label class="d-flex mb-0">
                        <input type="search" class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1" :placeholder="$t('label.search')" v-model="searchCommission" @keypress.enter="filterSearchCommission">
                        <button class="input-group-text d-inline-flex width-3 align-items-center justify-content-center border-bottom-left-radius-0 border-top-left-radius-0 border-left-0 search" @click="filterSearchCommission()">
                            <i class="fas fa-search"></i>
                        </button>
                    </label>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 mb-2">
                <date-range-picker class="w-100"
                    :minDate="minDate"
                    ref="picker"
                    v-model="dateRange"
                    :opens="'left'"
                    :autoApply="true"
                    :showDropdowns="true" 
                    :always-show-calendars="false"
                    :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                    @showCustomRange="showCustomRangeCalendars=true"
                    @update="filterByDate">
                </date-range-picker>
            </div>
            <div class="col-sm-12 col-md-6 mb-2">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0" for="serviceCategory">
                                <i class="fas fa-cart-arrow-down"></i>
                            </label>
                            <multiselect 
                                v-model="selectedOrderID" 
                                :options="arrOrderID" 
                                label="text" track-by="id" 
                                :searchable="true" 
                                :show-labels="false" 
                                openDirection="below" 
                                @select="filterByOrderID">
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6 mb-2">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0">
                                <i class="fas fa-receipt"></i>
                            </label>
                            <multiselect 
                                v-model="selectedReceiptID" 
                                :options="arrReceiptID" 
                                label="text" track-by="id" 
                                :searchable="true" 
                                :show-labels="false" 
                                openDirection="below" 
                                @select="filterByReceiptID">
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-4 mb-2">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0" for="serviceCategory">
                                <i class="fas fa-store"></i>
                            </label>
                            <multiselect  
                                v-model="selectedOutlet" 
                                label="text" track-by="id" 
                                :options="outlet" 
                                :searchable="false" 
                                :show-labels="false" 
                                openDirection="below" 
                                @select="filterByOutlet">
                                <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-4 mb-2">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0" for="serviceCategory">
                                <i class="fas fa-user"></i>
                            </label>
                            <multiselect  
                                v-model="selectedStaff" 
                                :options="staffs" 
                                group-values="staff" group-label="outlet" 
                                track-by="staffID" label="name" 
                                :show-labels="false" 
                                openDirection="below" 
                                @select="filterByStaff">
                                <span slot="noResult">{{$t('table.no_records')}}</span>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-4 mb-2">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0" for="serviceCategory">
                                <i class="fas fa-cash-register"></i>
                            </label>
                            <multiselect  
                                v-model="selectedPayment" 
                                label="text" track-by="id" 
                                :options="payment" 
                                :searchable="false" 
                                :show-labels="false" 
                                openDirection="below" 
                                @select="filterByPayment">
                                <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <a class="pl-3 link text-primary" @click="clearFilter()">{{$t('button_link.clear_filter')}}</a>
        </div>
        <div v-else class="row">
            <div class="col-sm-12 col-md-4">
                <date-range-picker class="w-100"
                    :minDate="minDate"
                    ref="picker"
                    v-model="dateRange"
                    :opens="'right'"
                    :autoApply="true"
                    :showDropdowns="true" 
                    :always-show-calendars="false"
                    :locale-data="{firstDay: 1, format: 'dd/mm/yyyy'}"
                    @showCustomRange="showCustomRangeCalendars=true"
                    @update="filterByDate">
                </date-range-picker>
            </div>
            <div class="col-sm-12 col-md-4">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0" for="serviceCategory">
                                <i class="fas fa-store"></i>
                            </label>
                            <multiselect  
                                v-model="selectedStaffOutlet" 
                                label="text" track-by="id" 
                                :options="staffOutlet" 
                                :searchable="false" 
                                :show-labels="false" 
                                openDirection="below" 
                                @select="filterByOutlet">
                                <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-4">
                <div class="form-group">
                    <div class="input-group">
                        <div class="input-group-prepend w-100">
                            <label class="input-group-text border-right-0" for="serviceCategory">
                                <i class="fas fa-user"></i>
                            </label>
                            <multiselect  
                                v-model="selectedAllStaff" 
                                :options="allStaffs" 
                                track-by="staffID" label="name" 
                                :show-labels="false" 
                                openDirection="below" 
                                @select="filterByAllStaff">
                                <span slot="noResult">{{$t('table.no_records')}}</span>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3">
            <ul v-show="selectedTab == 'category'" class="nav nav-tabs" >
                <li class="nav-item" v-for="i in 7" :key="i">
                    <a :class="{'active': selectedCategory == i-2}" class="nav-link" @click="filterByCategory((i-2))">{{i-1 == 0 ? $t('label.all', {'item': $t('label.category')}) :  $t('label.category') + ' '+ (i-1)}}</a>
                </li>
            </ul>
            <ul v-show="selectedTab == 'type'" class="nav nav-tabs" >
                <li class="nav-item" v-for="type in typeItems" :key="type.id">
                    <a :class="{'active': selectedType == type.id}" class="nav-link" @click="filterByType(type.id)">{{type.text}}</a>
                </li>
            </ul>
            <ul v-show="selectedTab == 'staff'" class="nav nav-tabs" >
                <li class="nav-item" v-for="payment in paymentTabItems" :key="payment.id">
                    <a :class="{'active': selectedPaymentTab.id == payment.id}" class="nav-link" @click="filterByPayment(payment)">{{payment.text}}</a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import _ from 'lodash';
import DateRangePicker from 'vue2-daterange-picker'
import {getMinDate} from '@/assets/js/dashboard/utilities.js'

import cst from './../../../../assets/js/dashboard/export-table-header'
import opt, {setStaffCommissionItems, calculateSalesReportDateTotal, calculateCategoryTotalRedeem, calculateEffortPercentage, getSubTotal} from './../../../../assets/js/dashboard/salonReport/salonReport'
import {convertTimestampToDateTime, dateRange, reorderObject, setAYearArr, setYearArr} from './../../../../assets/js/dashboard/utilities'
import {handleSessionExpired, getOutletName} from './../../../../assets/js/dashboard/dashboard'

export default {
    name: 'commissionFilter',
    components:{
        DateRangePicker
    },
    props: {
        selectedTab: { type: String },
        arrOrderID: { type: Array },
        arrReceiptID: { type: Array }
    },
    data(){
        let startDate = moment().toDate();
        let endDate = moment().toDate()
        return{
            minDate: getMinDate(),//moment().startOf('year').format('YYYY-MM-DD'),
            
            searchCommission: "", 
            dateRange: { startDate, endDate },
            selectedCategory: -1,
            orderIDFilter: "", receiptIDFilter: "",
            outletFilter: "", staffFilter: "",  dateFilter: "", generalFilter: "",
            staffs:[], selectedStaff: {staffID: "", name: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_staff')}), outletID: ""},
            allStaffs:[], selectedAllStaff: {},
            staffOutlet:[], selectedStaffOutlet: {},
            outlet: [], selectedOutlet: {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})},
            selectedType: "all",
            selectedOrderID: {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_report_order')})},
            selectedReceiptID: {id: 'all', text: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_receipt')})},
            selectedPayment: {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_report_payment')})},
            selectedPaymentTab: {id: "", text: this.$i18n.t('salon_report.sales.sales')},
            exportHeaders: [],
            exportFields: {},
            exportData: [], exportFileName: ""
        }
    },
    computed:{
        typeItems(){
            return [
                {id: "all", text: this.$i18n.t('label.all', {'item': ''})},
                {id: "service", text: this.$i18n.t('salon_report.item_types.service')},
                {id: "product", text: this.$i18n.t('salon_report.item_types.product')},
                {id: "package", text: this.$i18n.t('salon_report.item_types.package')},
            ]
        },
        paymentTabItems(){
            return[
                {id: "", text: this.$i18n.t('salon_report.sales.sales')},
                {id: "credits", text: this.$i18n.t('salon_report.sales.credit_redeem')},
                {id: "package", text: this.$i18n.t('salon_report.sales.package_redeem')},
                {id: "all", text: this.$i18n.t('label.all', {'item': ''})},
            ]
        },
        payment(){
            return[
                {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_report_payment')})},
                {id: "", text: this.$i18n.t('salon_report.redeem.sales')},
                {id: "credits", text: this.$i18n.t('salon_report.redeem.credits')},
                {id: "package", text: this.$i18n.t('salon_report.redeem.package')},
            ]
        },
        export_category(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.outlet')).toUpperCase()] = "outlet"
            ret[(this.$i18n.t('table.header.staff')).toUpperCase()] = "staff"
            ret[(this.$i18n.t('table.header.type')).toUpperCase()] = "type"
            ret[(this.$i18n.t('table.header.item') + this.$i18n.t('table.header.price')).toUpperCase()] = "price"
            ret[(this.$i18n.t('table.header.effort') + '('+ this.$i18n.t('subMenu.salon_report_sales') + ')').toUpperCase()] = "salesEffort"
            ret[(this.$i18n.t('subMenu.salon_report_credit')).toUpperCase()] = "credits"
            ret[(this.$i18n.t('table.header.effort') + '('+ this.$i18n.t('subMenu.salon_report_credit') + ')').toUpperCase()] = "creditEffort"
            ret[(this.$i18n.t('subMenu.salon_menu_package')).toUpperCase()] = "packages"
            ret[(this.$i18n.t('table.header.effort') + '('+ this.$i18n.t('subMenu.salon_menu_package') + ')').toUpperCase()] = "packageEffort"
            ret[(this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.effort')})).toUpperCase()] = "totalEffort"
            ret[(this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.fee')})).toUpperCase()] = "totalFee"
            return ret
        },
        export_type(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.item')).toUpperCase()] = "title"
            ret[(this.$i18n.t('table.header.type')).toUpperCase()] = "type"
            ret[( this.$i18n.t('table.header.amount')).toUpperCase()] = "price"
            ret[(this.$i18n.t('table.header.effort') + '('+ this.$i18n.t('subMenu.salon_report_sales') + ')').toUpperCase()] = "salesEffort"
            ret[(this.$i18n.t('table.header.fee') + '('+ this.$i18n.t('subMenu.salon_report_sales') + ')').toUpperCase()] = "salesFee"
            ret[(this.$i18n.t('table.header.quantity') + '('+ this.$i18n.t('subMenu.salon_report_sales') + ')').toUpperCase()] = "salesQty"
            ret[(this.$i18n.t('table.header.effort') + '('+ this.$i18n.t('subMenu.salon_report_credit') + ')').toUpperCase()] = "creditsEffort"
            ret[(this.$i18n.t('table.header.fee') + '('+ this.$i18n.t('subMenu.salon_report_credit') + ')').toUpperCase()] = "creditsFee"
            ret[(this.$i18n.t('table.header.effort') + '('+ this.$i18n.t('subMenu.salon_menu_package') + ')').toUpperCase()] = "packageEffort"
            ret[(this.$i18n.t('table.header.fee') + '('+ this.$i18n.t('subMenu.salon_menu_package') + ')').toUpperCase()] = "packageFee"
            ret[(this.$i18n.t('table.value.redeem') + ' ' + this.$i18n.t('table.header.quantity')).toUpperCase()] = "redeemQty"
            ret[(this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.effort')})).toUpperCase()] = "totalEffort"
            ret[(this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.fee')})).toUpperCase()] = "totalFee"
            ret[(this.$i18n.t('table.header.total', {'item': this.$i18n.t('table.header.quantity')})).toUpperCase()] = "totalQty"
            return ret
        },
        export_item(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.date')).toUpperCase()] = "createDate"
            ret[(this.$i18n.t('subMenu.salon_setting_receipt') + ' #').toUpperCase()] = "receiptID"
            ret[(this.$i18n.t('table.header.item')).toUpperCase()] = "item.title"
            ret[(this.$i18n.t('table.header.type')).toUpperCase()] = "item.type"
            ret[(this.$i18n.t('table.header.outlet')).toUpperCase()] = "outlet"
            ret[(this.$i18n.t('subMenu.my_salon_member') + ' ' +this.$i18n.t('table.header.name')).toUpperCase()] = "member.displayName"
            ret[(this.$i18n.t('table.header.contact')).toUpperCase()] = "member.mobile"
            ret[(this.$i18n.t('subMenu.salon_report_payment')).toUpperCase()] = "redeem"
            ret[(this.$i18n.t('table.header.amount')).toUpperCase()] = "price"
            ret[(this.$i18n.t('subMenu.salon_setting_staff') + ' 1').toUpperCase()] = "staffs.staff1.name"
            ret[(this.$i18n.t('table.header.effort') + ' 1').toUpperCase()] = "staffs.staff1.effort"
            ret[(this.$i18n.t('table.header.effort_percentage') + ' 1').toUpperCase()] = "staffs.staff1.pctg"
            ret[(this.$i18n.t('table.header.fee') + ' 1').toUpperCase()] = "staffs.staff1.fee"
            ret[(this.$i18n.t('subMenu.salon_setting_staff') + ' 2').toUpperCase()] = "staffs.staff2.name"
            ret[(this.$i18n.t('table.header.effort') + ' 2').toUpperCase()] = "staffs.staff2.effort"
            ret[(this.$i18n.t('table.header.effort_percentage') + ' 2').toUpperCase()] = "staffs.staff2.pctg"
            ret[(this.$i18n.t('table.header.fee') + ' 2').toUpperCase()] = "staffs.staff2.fee"
            ret[(this.$i18n.t('subMenu.salon_setting_staff') + ' 3').toUpperCase()] = "staffs.staff3.name"
            ret[(this.$i18n.t('table.header.effort') + ' 3').toUpperCase()] = "staffs.staff3.effort"
            ret[(this.$i18n.t('table.header.effort_percentage') + ' 3').toUpperCase()] = "staffs.staff3.pctg"
            ret[(this.$i18n.t('table.header.fee') + ' 3').toUpperCase()] = "staffs.staff3.fee"
            ret[(this.$i18n.t('subMenu.salon_setting_staff') + ' 4').toUpperCase()] = "staffs.staff4.name"
            ret[(this.$i18n.t('table.header.effort') + ' 4').toUpperCase()] = "staffs.staff4.effort"
            ret[(this.$i18n.t('table.header.effort_percentage') + ' 4').toUpperCase()] = "staffs.staff4.pctg"
            ret[(this.$i18n.t('table.header.fee') + ' 4').toUpperCase()] = "staffs.staff4.fee"
            return ret
        },
        export_staff(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.date')).toUpperCase()] = "createDate"
            ret[(this.$i18n.t('salon_report.item_types.service')).toUpperCase()] = "service"
            ret[(this.$i18n.t('salon_report.item_types.product')).toUpperCase()] = "product"
            ret[(this.$i18n.t('salon_report.item_types.package')).toUpperCase()] = "package"
            ret[(this.$i18n.t('salon_report.item_types.outstandings')).toUpperCase()] = "outstandings"
            ret[(this.$i18n.t('label.total')).toUpperCase()] = "total"
            return ret
        },
    },
    watch:{
        "$i18n.locale"(val){
            this.setOutletOptions()
            var b = Object.assign({}, this.selectedOutlet)
            this.selectedOutlet = this.outlet.filter(obj=> obj.id == b.id)[0]

            var a = Object.assign({}, this.selectedOrderID)
            this.selectedOrderID = this.arrOrderID.filter(obj=> obj.id == a.id)[0]

            var c = Object.assign({}, this.selectedReceiptID)
            this.selectedReceiptID = this.arrReceiptID.filter(obj=> obj.id == c.id)[0]

            var d = Object.assign({}, this.selectedPayment)
            this.selectedPayment = this.payment.filter(obj=> obj.id == d.id)[0]

            var e = Object.assign({}, this.selectedStaff)
            for(var j=0; j<this.staffs.length; j++){
                this.staffs[j].outlet = this.staffs[j].outletID == "all" ? 
                this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')}) :
                this.outlet.filter(obj=> obj.id == this.staffs[j].outletID )[0].text

                for(var k=0; k<this.staffs[j].staff.length; k++){
                    if(this.staffs[j].staff[k].staffID == ""){
                       this.staffs[j].staff[k].name = this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_staff')})
                    }else if(this.staffs[j].staff[k].staffID == "no"){
                       this.staffs[j].staff[k].name = this.$i18n.t('label.no', {'item': this.$i18n.t('subMenu.salon_setting_staff')})
                    }
                }
            }
            for(var i=0; i<this.staffs.length; i++){
                if(this.staffs[i].outletID == this.selectedOutlet.id){
                    this.selectedStaff = this.staffs[i].staff.filter(obj=> obj.staffID == e.staffID)[0]
                }
            }

        },
    },
    methods:{
        clearFilter(){
            let startDate = moment().toDate();
            let endDate = moment().toDate()

            this.dateRange = { startDate, endDate }
            this.searchCommission = "";
            this.selectedOrderID = {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_report_order')})}
            this.selectedReceiptID = {id: 'all', text: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_receipt')})}
            this.selectedOutlet = {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}
            this.selectedStaff = {staffID: "", name: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_staff')}), outletID: ""}       
            this.selectedType = "all"
            this.selectedCategory = -1

            this.filterItems()
        },
        filterSearchCommission(){
            this.filterItems()
        },
        filterByPayment(item){
            if(this.selectedTab == 'staff'){
                this.selectedPaymentTab = item
            }else{
                this.selectedPayment = item
            }
            this.filterItems()
        },
        filterByOrderID(item){
            this.selectedOrderID = item
            this.filterItems()
        },
        filterByReceiptID(item){
            this.selectedReceiptID = item
            this.filterItems()
        },
        filterByOutlet(item){
            
            if(this.selectedTab == 'staff'){
                this.selectedStaffOutlet = item
                this.setStaffOptions(item)
            }else{
                this.selectedOutlet = item
                this.selectedStaff = {staffID: "", name: this.$i18n.t('label.all', {'item': this.$i18n.t('subMenu.salon_setting_staff')}), outletID: ""}  
            }
            this.filterItems()
        },
        filterByAllStaff(item){
            this.selectedAllStaff = item
            this.filterItems()
        },
        filterByStaff(item){
            this.selectedStaff = item
            for(var i=0; i<this.outlet.length; i++){
                if(item.outletID == this.outlet[i].id){
                    this.selectedOutlet = this.outlet[i];
                    break;
                }
            }
            this.filterItems()
        },
        filterByDate(date){
            this.dateRange = date;
            this.filterItems()
        },
        filterByCategory(id){
            this.selectedCategory = id;
            this.filterItems()
       },
        filterByType(type){
            this.selectedType = type;
            this.filterItems()
        },
        filterItems(){
            var data = {
                date: this.dateRange,
                order: this.selectedOrderID,
                receipt: this.selectedReceiptID,
                outlet: this.selectedTab == 'staff' ? this.selectedStaffOutlet : this.selectedOutlet,
                staff: this.selectedTab == 'staff' ? this.selectedAllStaff :  this.selectedStaff,
                payment: this.selectedTab == 'staff' ? this.selectedPaymentTab : this.selectedPayment,
                type: this.selectedType,
                category: this.selectedCategory, 
                search: this.searchCommission
            }
            this.$emit('filterCommission', data);
        },
        getExportData(){
            var exportData = this.setExportData(this.$store.state.commission, this.selectedTab);
            return exportData;
        },
        setExportData(d, tab){
            var data = d.slice()
            var exportData = []
            var emptyStaff = {
                staffID: '',
                name: '-',
                effort: 0,
                pctg: 0,
                pctg2: 0,
                fee: 0
            }
            var outlets = JSON.parse(this.$store.state.outlets);
            let arrTab = this.$i18n.messages[this.$i18n.locale].tab.reportCommissionTabs
            var tabHeader = arrTab.filter(obj=> obj.id == tab)[0].text
            switch(tab){
                case"category":
                // tabHeader = arrTab.filter(obj=> obj.id == tab)[0].text
                this.exportFields = this.export_category
                var group = _.groupBy(data, 'outletID');
                var catIndex = 0;
                for(var g in group){
                    let grp =  group[g].reduce((result, item) => {
                    var staffs = item.staffs;
                    if(staffs.length != 0){
                        for(var i=0; i<staffs.length; i++){
                            if(!(staffs[i].staffID in result)){ 
                                var nItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
                                nItem['staffName'] = staffs[i].name
                                result[staffs[i].staffID] =[nItem]
                            }else{
                                if (result[staffs[i].staffID].filter(el => el.completedID == item.completedID).length == 0) {
                                    var _ntem = Object.assign({}, JSON.parse(JSON.stringify(item)))
                                    _ntem['staffName'] = staffs[i].name
                                    result[staffs[i].staffID] =[...result[staffs[i].staffID],_ntem]
                                }
                            }
                        }
                    }else{
                        result['noStaff'] = [...result['noStaff'] ||[], item]
                    }
                    return result;
                    }, {});
                    for(var o in grp){
                        var groupItems = _.groupBy(grp[o], 'item.type')
                        var typeItems = {
                            service: "service" in groupItems ? groupItems["service"] : [],
                            product: "product" in groupItems ? groupItems["product"] : [],
                            package: "package" in groupItems ? groupItems["package"] : [],
                            // discount: "discount" in groupItems ? groupItems["discount"] : [],
                            outstandings: "outstandings" in groupItems ? groupItems["outstandings"] : [],
                        }
                        for(var typeItem in typeItems){
                            let groupItems = typeItems[typeItem];
                            typeItems[typeItem]["info"] = grp[o]
                            typeItems[typeItem] = {
                                sales: 0, 
                                salesEffort: 0,

                                credits: 0, 
                                creditEffort: 0, 

                                packages: 0,
                                packageEffort: 0,

                                fee: 0
                            };
                            for(var y=0; y<groupItems.length; y++){
                                typeItems[typeItem]= calculateCategoryTotalRedeem(o ,groupItems[y]["redeem"], groupItems[y]["price"], groupItems[y]["discount"], groupItems[y]["outstandings"], groupItems[y]["staffs"], typeItems[typeItem])
                            }
                        }
                        typeItems["total"] = {
                            sales: typeItems.service.sales + typeItems.product.sales + typeItems.package.sales + typeItems.outstandings.sales,
                            salesEffort: typeItems.service.salesEffort + typeItems.product.salesEffort + typeItems.package.salesEffort + typeItems.outstandings.salesEffort,
                            
                            credits: typeItems.service.credits + typeItems.product.credits + typeItems.package.credits + typeItems.outstandings.credits,
                            creditEffort: typeItems.service.creditEffort + typeItems.product.creditEffort + typeItems.package.creditEffort + typeItems.outstandings.creditEffort,
                            
                            packages: typeItems.service.packages + typeItems.product.packages + typeItems.package.packages + typeItems.outstandings.packages,
                            packageEffort: typeItems.service.packageEffort + typeItems.product.packageEffort + typeItems.package.packageEffort + typeItems.outstandings.packageEffort,
                            
                            fee: typeItems.service.fee + typeItems.product.fee + typeItems.package.fee + typeItems.outstandings.fee,
                        }
                        
                        for(var tItem in typeItems){
                            typeItems[tItem]["info"] = grp[o]
                        }
                        for(var t in typeItems){
                            var info = typeItems[t].info
                            exportData.push(
                                {   
                                    index: catIndex + 1,
                                    outlet: getOutletName(info[0].outletID, outlets),
                                    staff: info[0].staffs.length == 0 ? this.$i18n.t('label.no', {'item': this.$i18n.t('subMenu.salon_setting_staff')}) : info[0].staffName,
                                    type:  t == 'total' ? this.$i18n.t('label.total') : this.$i18n.t('salon_report.item_types.' + t),
                                    price: typeItems[t].sales,
                                    salesEffort: typeItems[t].salesEffort,
                                    credits: typeItems[t].credits,
                                    creditEffort: typeItems[t].creditEffort,
                                    packages: typeItems[t].packages,
                                    packageEffort: typeItems[t].packageEffort,
                                    totalEffort: typeItems[t].salesEffort + typeItems[t].creditEffort + typeItems[t].packageEffort,
                                    totalFee: typeItems[t].fee
                                }
                            )
                            catIndex++;
                        }
                    }
                }
                break;
                case"type":
                    // tabHeader = "Type"
                    this.exportFields = this.export_type
                    var dataObj = _.groupBy(data, 'item.itemID');
                    var index = 0;
                    for(var obj in dataObj){
                        var items = dataObj[obj]
                        dataObj[obj]["totalRedeem"] = {
                            sales: 0, 
                            salesQty: 0,
                            salesEffort: 0,
                            salesFee: 0,

                            credits: 0, 
                            creditsQty: 0,
                            creditEffort: 0, 
                            creditFee: 0,

                            packages: 0,
                            packagesQty: 0,
                            packageEffort: 0,
                            packageFee: 0
                        };
                        var subTotal = 0;
                        for(var x=0; x<items.length; x++){
                            dataObj[obj]["totalRedeem"] = calculateCategoryTotalRedeem(this.selectedStaff.staffID, items[x]["redeem"], items[x]["price"], items[x]["discount"], items[x]["outstandings"], items[x]["staffs"], dataObj[obj]["totalRedeem"])
                            subTotal += getSubTotal(items[x].price, items[x].discount, items[x].outstandings)
                        }
                        exportData.push(
                            {
                                index: index + 1,
                                title: items[0].item.title,
                                type: this.$i18n.t('salon_report.item_types.' + items[0].item.type),
                                price: subTotal,
                                salesEffort: dataObj[obj].totalRedeem.salesEffort,
                                salesQty: dataObj[obj].totalRedeem.salesQty,
                                salesFee: dataObj[obj].totalRedeem.salesFee,
                                creditsEffort: dataObj[obj].totalRedeem.creditEffort,
                                creditsFee: dataObj[obj].totalRedeem.creditFee,
                                packageEffort: dataObj[obj].totalRedeem.packageEffort,
                                packageFee: dataObj[obj].totalRedeem.packageFee,
                                redeemQty: dataObj[obj].totalRedeem.creditsQty + dataObj[obj].totalRedeem.packagesQty,
                                totalQty: dataObj[obj].totalRedeem.salesQty + dataObj[obj].totalRedeem.creditsQty + dataObj[obj].totalRedeem.packagesQty,
                                totalEffort: dataObj[obj].totalRedeem.salesEffort + dataObj[obj].totalRedeem.creditEffort + dataObj[obj].totalRedeem.packageEffort,
                                totalFee: dataObj[obj].totalRedeem.salesFee + dataObj[obj].totalRedeem.creditFee + dataObj[obj].totalRedeem.packageFee
                            }
                        )
                        index++    
                    }
                    break;
                case"item":
                    // tabHeader = "Item"
                    this.exportFields = this.export_item;
                    for(var i=0; i<data.length; i++){
                        var price = data[i]["price"]
                        data[i]["index"] = i + 1;
                        data[i]["createDate"] =  moment.unix(data[i]["createDate"]).format(this.$msg.CST.DATE_TIME_24);
                        data[i].item.type = this.$i18n.t('salon_report.item_types.' + data[i].item.type),
                        data[i]["price"]= getSubTotal(data[i]["price"], data[i]["discount"], data[i]["outstandings"])
                        data[i]["outlet"] = getOutletName(data[i].outletID, outlets)
                        switch(data[i]["redeem"]){
                            case"":
                            data[i]["redeem"] = this.$i18n.t('salon_report.redeem.sales')
                            break; 
                            case"credits":
                            data[i]["redeem"] = this.$i18n.t('salon_report.redeem.credits')  
                            break; 
                            case"package":
                            data[i]["redeem"] = this.$i18n.t('salon_report.redeem.package') 
                            break; 
                        }
                        var staffs = data[i]["staffs"];
                        var staffsObj = {}
                        for(var j=0; j<4; j++){
                            if(j<staffs.length){
                                staffs[j]["pctg"] = data[i]["price"] == 0 ? "-" : calculateEffortPercentage(getSubTotal(price, data[i]["discount"], data[i]["outstandings"]), staffs[j]["effort"]) + "%"
                                staffsObj["staff" + (j+1)] = staffs[j]
                            }else{
                                staffsObj["staff" + (j+1)] = emptyStaff    
                            }
                        }
                        data[i]["staffs"] = staffsObj;
                    }
                    exportData = data
                    break;
                case"staff":
                    
                    tabHeader += ' '+ this.selectedAllStaff.name + " (" + this.selectedPaymentTab.text + ")"
                    this.exportFields = this.export_staff
                    
                    var startDate = moment(this.dateRange.startDate)
                    var endDate = moment(this.dateRange.endDate)

                    var range = dateRange(startDate, endDate);
                    var staffID = this.selectedAllStaff.staffID
                    var $vm = this
                    var item = {}
                    if(range.length < 365){
                        var rangeArr = range.map(date => moment(date).format($vm.$msg.CST.DATE_FORMAT))

                        for(var k=0; k<data.length; k++){
                            data[k]["formatDate"] = moment.unix(data[k].createDate).format(this.$msg.CST.DATE_FORMAT)
                        }
                        var groups = _.groupBy(data, "formatDate")
                        for(var r=0; r<rangeArr.length; r++){
                            if(!(rangeArr[r] in groups)){
                                groups[rangeArr[r]] = []
                            }
                        }
                        var reordered = reorderObject(groups)
                        item = setStaffCommissionItems(reordered, staffID)
                    }else if(range.length == 366 || range.length == 365){
                        var yearObj = setAYearArr(moment(startDate).format('YYYY'))
                        var indx = 0
                        for(var m in yearObj){
                            for(var l=0; l<data.length; l++){
                                var createDate = new Date(data[l].createDate*1000);
                                if(createDate.getMonth() == indx){
                                    yearObj[m].push(data[l])
                                }
                            }
                            indx++;
                        }
                        item = setStaffCommissionItems(yearObj, staffID)
                    }else{
                        var yearsObj = setYearArr(startDate.getFullYear(), endDate.getFullYear())
                        for(var z in yearsObj){
                            for(var dt=0; dt<data.length; dt++){
                                var cDate = new Date(data[dt].createDate*1000);
                                if(cDate.getFullYear() == z){
                                    yearsObj[z].push(data[dt])
                                }
                            }
                        }
                        item = setStaffCommissionItems(yearsObj, staffID)
                    }
                    var idx = 0
                    for(var date in item){
                        exportData.push(
                            {
                                index: idx + 1,
                                date: date,
                                service: item[date].service,
                                product: item[date].product,
                                package: item[date].package,
                                outstandings: item[date].outstandings,
                                total: item[date].total,
                            }
                        )
                        idx++
                    }
                    var objDateTotal = calculateSalesReportDateTotal(item)
                    exportData.push(
                        {
                            index: "",
                            date: this.$i18n.t('label.total'),
                            service: objDateTotal.service,
                            product: objDateTotal.product,
                            package: objDateTotal.package,
                            outstandings: objDateTotal.outstandings,
                            total: objDateTotal.total,
                        }
                    )
                break;
            }
            var strDate = moment(this.dateRange.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(this.dateRange.endDate).format(this.$msg.CST.DATE_FORMAT);
            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_commission`) + "_" + strDate
            this.exportHeaders = [
                header,
                this.$i18n.t('salon_report.view') + tabHeader,
                this.$i18n.t('table.header.date') + ": " + strDate,
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), 
                this.$i18n.t('label.outlet') + ": " + (this.selectedOutlet.id == "all" ? this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')}) : getOutletName(this.selectedOutlet.id, outlets)),
                " "];
            this.exportFileName = header.split(" ").join("_") +  this.$msg.REPORT.CSV
            this.exportData = exportData
            // return exportData;
        },
        setOutletOptions(){
            var outlets = JSON.parse(this.$store.state.outlets);

            this.staffOutlet = outlets.slice()
            this.selectedStaffOutlet = this.staffOutlet[0]

            this.outlet = [{id: "all",text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')})}]
            this.outlet.push(...outlets);

            if (this.outlet[1]) {
                this.selectedOutlet = this.outlet[1]
            }
        },
        async setStaffOptions(outlet){
            let $vm = this;
            let QUERY_STRING =  "/" + outlet.id + this.$api.STAFF 
            const url =  this.$api.OUTLET + QUERY_STRING;

            var result = []
            this.allStaffs = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.staff
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })

            for(var i=0; i<result.length; i++){
                $vm.allStaffs.push({
                    staffID: result[i].staffID,
                    name: result[i].name
                })
            }
            $vm.selectedAllStaff = $vm.allStaffs[0]
        },
    },
    mounted(){
        let $vm = this;

        $vm.setOutletOptions()
        $vm.setStaffOptions(JSON.parse(this.$store.state.outlets)[0])
        $vm.filterItems()
    }
}
</script>
<style scoped>
.link, .nav-item{
    cursor: pointer;
}
.search:hover{
    background: #d6d6d6;
    border: 1px solid #d6d6d6;
}
.visible-card{
    overflow: visible !important;
}
</style>